 

export enum DealType {
    Acquisition = 'Acquisition',
    Development = 'Development',
}

export const DealTypeToId: Record<DealType, number> = {
    [DealType.Acquisition]: 1,
    [DealType.Development]: 2,
};

export const DEFAULT_NYC_COORDINATES = { lat: 40.7128, lng: -74.0060 };
